import React from "react";

const FullScreenSpinner: React.FC = () => (
    <div className="flex items-center justify-center h-screen w-full">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
    </div>
);

export default FullScreenSpinner;
